/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleViewResponse extends models.RoleBase {
    getFixupPrototypeFunction() { return RoleViewResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleViewResponse>): RoleViewResponse {
        let obj = Object.assign(new RoleViewResponse(), model);
        RoleViewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleViewResponse>): RoleViewResponse {
        if (!model) return null;
        return RoleViewResponse.newInstance(<RoleViewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleViewResponse) {
        if (!obj) return;

        models.RoleViewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleViewResponse): boolean {
        if (models.RoleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RoleViewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * ID of the Role. Auto generated and unique in the CoreStack system
     */
    id: string;

    /**
     * Status of the role
     */
    status: models.RoleStatus;

    /**
     * Permission policies for the role, keyed by policy name
     */
    policy: any;

    /**
     * Category of the role - default or custom
     */
    category: string;

    /**
     * User who created the role
     */
    created_by: string;

    /**
     * Date and time when the role was created
     */
    created_at: Date;

    /**
     * User who last updated the role
     */
    updated_by: string;

    /**
     * Date and time when the role was last updated
     */
    updated_at: Date;

}
